import { createContext } from 'react';
import { IUserDataContext } from './types';

const UserDataContext = createContext<IUserDataContext | undefined>(undefined);

export default UserDataContext;
